/**
 * Circuit breaker — pausa flush após falhas consecutivas.
 */

const FAILURE_THRESHOLD = 5;
const OPEN_DURATION_MS = 30_000;

let consecutiveFailures = 0;
let openUntil = 0;

export function recordBatchFailure(): void {
  consecutiveFailures++;
  if (consecutiveFailures >= FAILURE_THRESHOLD) {
    openUntil = Date.now() + OPEN_DURATION_MS;
  }
}

export function recordBatchSuccess(): void {
  consecutiveFailures = 0;
  openUntil = 0;
}

export function isCircuitOpen(): boolean {
  if (Date.now() < openUntil) return true;
  if (openUntil > 0 && Date.now() >= openUntil) {
    consecutiveFailures = 0;
    openUntil = 0;
  }
  return false;
}

export function _testResetCircuitBreaker(): void {
  consecutiveFailures = 0;
  openUntil = 0;
}
